import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';

interface IUserParameters {
  parametersToGet?: string;
  enabled?: boolean;
}
export const useFetchUserParameters = (params: IUserParameters) => {
  const { parametersToGet, enabled = true } = params;
  const queryString = toQueryString({ parametersToGet } as unknown as QueryParamObject);
  const url = queryString ? `${API_URLS.USER_PARAMETERS}?${queryString}` : API_URLS.USER_PARAMETERS;
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['user-parameters', parametersToGet],
    queryFn: () => {
      return get(url);
    },
    staleTime: 60 * 1000, // 1 minute
    enabled: enabled,
  });

  return { data: error ? undefined : (data ?? []), isLoading, error, refetch };
};
